import PhotoRoll from './photo_roll';

export default PhotoRoll;
